(() => {
  ['contextmenu', 'dragstart'].forEach((name) => {
    document.addEventListener(name, (event) => {
      if (event.target.closest('img, picture, a:has(img), .product-gallery__main, .fixed-sets__media')) event.preventDefault();
    }, true);
  });
  const dialog = document.querySelector('[data-image-viewer]');
  if (!dialog) return;
  const viewport = dialog.querySelector('[data-viewer-viewport]');
  const picture = dialog.querySelector('[data-viewer-image]');
  const cartButton = dialog.querySelector('[data-viewer-cart]');
  let purchaseButton;
  cartButton?.addEventListener('click', () => {
    if (!purchaseButton || purchaseButton.disabled) return;
    dialog.close();
    // The shared product cart handler owns this button, including variant and quantity.
  });
  let source, scale = 1, fitWidth = 0;
  const pointers = new Map();
  let moved = false, origin;
  const eligible = (img) => {
    if (img.closest('a, button, [role="button"], [aria-hidden="true"], .cart-page, .kova-studio')) return false;
    for (let el = img; el && el.id !== 'MainContent'; el = el.parentElement) {
      if (/(hero|banner|logo|icon|thumb|preview)/i.test(el.className || '')) return false;
    }
    return true;
  };
  const init = () => document.querySelectorAll('#MainContent img:not([data-image-viewable])').forEach((img) => {
    if (!eligible(img)) return;
    img.dataset.imageViewable = '';
    img.tabIndex = 0;
    img.setAttribute('role', 'button');
    img.setAttribute('aria-haspopup', 'dialog');
    img.setAttribute('aria-label', `View image: ${img.alt || 'Image detail'}`);
  });
  const zoom = (value) => {
    if (!fitWidth) return;
    const before = scale;
    scale = Math.max(1, Math.min(4, value));
    picture.style.width = `${fitWidth * scale}px`;
    viewport.scrollLeft = (viewport.scrollLeft + viewport.clientWidth / 2) * scale / before - viewport.clientWidth / 2;
    viewport.scrollTop = (viewport.scrollTop + viewport.clientHeight / 2) * scale / before - viewport.clientHeight / 2;
  };
  const fit = () => {
    const ratio = picture.naturalWidth / picture.naturalHeight;
    if (!Number.isFinite(ratio) || ratio <= 0) return;
    fitWidth = Math.min(viewport.clientWidth, viewport.clientHeight * ratio, picture.naturalWidth);
    zoom(1);
    viewport.scrollTo(0, 0);
  };
  const open = (img) => {
    source = img;
    if (cartButton) {
      purchaseButton = img.closest('[data-kova-product]')?.querySelector('[data-add-standard]');
      cartButton.hidden = !purchaseButton;
      cartButton.disabled = !purchaseButton || purchaseButton.disabled;
    }
    fitWidth = 0;
    picture.alt = img.alt;
    picture.onload = fit;
    picture.onerror = () => { picture.alt = 'Image unavailable'; };
    const url = new URL(img.currentSrc || img.src, location.href);
    if (url.searchParams.has('width')) url.searchParams.set('width', '2400');
    picture.src = url.href;
    dialog.showModal();
    if (picture.complete) fit();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('a, button, [data-image-viewer]')) return;
    const images = event.target.matches('[data-image-viewable]')
      ? [event.target] : event.target.querySelectorAll('[data-image-viewable]');
    for (const img of images) {
      const bounds = img.getBoundingClientRect();
      if (event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom) {
        open(img);
        break;
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.target.matches('[data-image-viewable]') && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      open(event.target);
    }
  });
  dialog.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { pointers.clear(); source?.focus({ preventScroll: true }); });
  viewport.addEventListener('wheel', (event) => {
    if (!event.ctrlKey) return;
    event.preventDefault();
    zoom(scale * Math.exp(-event.deltaY * 0.01));
  }, { passive: false });
  viewport.addEventListener('click', (event) => {
    const bounds = picture.getBoundingClientRect();
    const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (!moved && outside) dialog.close();
  });
  const distance = () => {
    const [a, b] = [...pointers.values()];
    return Math.hypot(a.x - b.x, a.y - b.y);
  };
  viewport.addEventListener('pointerdown', (event) => {
    if (!pointers.size) { moved = false; origin = { x: event.clientX, y: event.clientY }; }
    else moved = true;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    viewport.setPointerCapture(event.pointerId);
  });
  viewport.addEventListener('pointermove', (event) => {
    const previous = pointers.get(event.pointerId);
    if (!previous) return;
    if (Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > 4) moved = true;
    const oldDistance = pointers.size === 2 ? distance() : 0;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (oldDistance > 0) zoom(scale * distance() / oldDistance);
    else {
      viewport.scrollLeft -= event.clientX - previous.x;
      viewport.scrollTop -= event.clientY - previous.y;
    }
  });
  ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => viewport.addEventListener(name, (event) => pointers.delete(event.pointerId)));
  window.addEventListener('resize', () => { if (dialog.open) fit(); });
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.querySelector('#MainContent') || document.body, {childList: true, subtree: true});
  init();
})();
